<template>
  <div class="entity-detail">
    <AppHeader />

    <EntityDetailSkeleton v-if="loading" />

    <template v-else-if="detail">
      <!-- 人物详情 -->
      <template v-if="entityType === 'renwu'">
        <PersonHero :detail="detail" />
        <OrgEventTimeline
          v-if="orgEventList.length"
          class="entity-detail__body entity-detail__event"
          :person="orgEventPerson"
          :event-list-data="orgEventList"
          :coordinate="orgEventCoordinate"
        />
        <SpaceMap v-if="spaceMapData.length" class="entity-detail__body" ref="spaceMap" :map-data="spaceMapData" />
      </template>

      <!-- 机构详情 -->
      <template v-else-if="entityType === 'jigou'">
        <div class="entity-detail__body entity-detail__body--top">
          <OrgIntro :detail="detail" />
        </div>
        <OrgEventTimeline
          v-if="orgEventList.length"
          class="entity-detail__body entity-detail__event"
          :person="orgEventPerson"
          :event-list-data="orgEventList"
          :coordinate="orgEventCoordinate"
        />
      </template>

      <!-- 地点详情 -->
      <template v-else-if="entityType === 'didian'">
        <div class="entity-detail__body entity-detail__body--top">
          <LocationIntro :detail="detail" />
        </div>
      </template>

      <!-- 事件详情 -->
      <template v-else-if="entityType === 'shijian'">
        <div class="entity-detail__body entity-detail__body--top">
          <EventIntro :detail="detail" />
        </div>
      </template>

      <div class="entity-detail__body">
        <!-- <EntityMediaAttributes
          v-if="detail.mediaAttributes && detail.mediaAttributes.length"
          :items="detail.mediaAttributes"
        /> -->
        <EntityKnowledgeGraph
          :graph-data="graphData"
          :loading="graphLoading"
        />
        <RelatedResources
          v-if="relatedTotal > 0"
          :list="relatedResources"
          :total="relatedTotal"
          :loading="relatedLoading"
          :page="relatedPage"
          :page-size="relatedPageSize"
          @page-change="loadRelatedResources"
        />
      </div>
    </template>

    <div v-else class="entity-detail__empty">
      <p>未找到该知识实体</p>
      <router-link to="/knowledge" class="entity-detail__back">返回史料知识</router-link>
    </div>

    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import SpaceMap from './detail/components/SpaceMap.vue'
import OrgEventTimeline from './detail/components/Event.vue'
import PersonHero from './detail/components/PersonHero.vue'
import OrgIntro from './detail/components/OrgIntro.vue'
import LocationIntro from './detail/components/LocationIntro.vue'
import EventIntro from './detail/components/EventIntro.vue'
import EntityMediaAttributes from './detail/components/EntityMediaAttributes.vue'
import EntityKnowledgeGraph from './detail/components/EntityKnowledgeGraph.vue'
import RelatedResources from './detail/components/RelatedResources.vue'
import EntityDetailSkeleton from './detail/components/EntityDetailSkeleton.vue'
import {
  fetchKnowledgeEntityDetail,
  fetchEntityRelatedResources,
  fetchKnowledgeEntityGraph,
  fetchKnowledgeRelatedEntities,
  mapRelatedEntitiesToEventData,
  mapKnowledgeDetail,
  mapKnowledgeGraph,
  fetchKnowledgeSpaceTime
} from '@/api/knowledge'
import { recordBrowseHistory, LOG_HISTORY_TYPE } from '@/utils/browseHistory'

const VALID_TYPES = ['renwu', 'jigou', 'didian', 'shijian']

export default {
  name: 'EntityDetail',
  components: {
    AppHeader,
    AppFooter,
    PersonHero,
    OrgIntro,
    LocationIntro,
    EventIntro,
    EntityMediaAttributes,
    EntityKnowledgeGraph,
    RelatedResources,
    SpaceMap,
    OrgEventTimeline,
    EntityDetailSkeleton
  },
  data() {
    return {
      spaceMapData: [],
      detail: null,
      loading: false,
      relatedResources: [],
      relatedTotal: 0,
      relatedLoading: false,
      relatedPage: 1,
      relatedPageSize: 10,
      relatedEntities: [],
      relatedEntitiesLoading: false,
      orgEventList: [],
      orgEventCoordinate: [],
      graphData: { nodes: [], relations: [], focusEntityId: null, focusNodeId: null, hasData: false },
      graphLoading: false
    }
  },
  computed: {
    entityType() {
      return this.$route.params.type
    },
    orgEventPerson() {
      if (!this.detail) {
        return { name: '', img: '', info: '' }
      }
      const fields = this.detail.fields || []
      let info = ''
      if (this.entityType === 'renwu') {
        const bioField = fields.find(
          (field) => field.code === 'biography' || field.code === 'renwugaishu'
        )
        info = (bioField && bioField.value && bioField.value !== '-')
          ? bioField.value
          : (this.detail.biography && this.detail.biography !== '暂无介绍' ? this.detail.biography : '')
      } else {
        const descField = fields.find(
          (field) => field.code === 'organizationDescription' || field.code === 'jigoujianjie'
        )
        info = descField && descField.value && descField.value !== '-' ? descField.value : ''
      }
      return {
        name: this.detail.title || '',
        img: (this.detail.gallery && this.detail.gallery[0]) || '',
        info
      }
    }
  },
  watch: {
    '$route.params.id'() {
      this.loadDetail()
    },
    '$route.params.type'() {
      this.loadDetail()
    }
  },
  mounted() {
    document.documentElement.classList.add('hide-scrollbar')
    this.loadDetail()
  },
  beforeDestroy() {
    document.documentElement.classList.remove('hide-scrollbar')
  },
  methods: {
    requestSpaceMapData() {
      const { id } = this.$route.params
      fetchKnowledgeSpaceTime({
        nodeId: id,
        identityId: '',
        limit: 100
      }).then(res => {
        if (res.code === 2000) {
          if (res.nodes && res.nodes.length === 0) {
            this.spaceMapData = []
            return
          }
          const { nodes, relations } = res
          const ary = []
          nodes.slice(1, 1000).filter(item => item.property.didianzuobiao).forEach(item => {
            const { property } = item
            if (property.didianzuobiao && typeof property.didianzuobiao === 'string') {
              try {
                property.didianzuobiao = JSON.parse(property.didianzuobiao)
                if (typeof property.didianzuobiao.lat === 'string') {
                  property.didianzuobiao.lat = Number(property.didianzuobiao.lat)
                }
                if (typeof property.didianzuobiao.lng === 'string') {
                  property.didianzuobiao.lng = Number(property.didianzuobiao.lng)
                }
              } catch (error) {
                console.log(error)
              }
            }
            const [link] = relations.filter(v => v.startId === this.spaceMapNodeId && v.endId === item.id)
            if (link) {
              item.property = { ...property, relation: link.type }
            }
            ary.push(item)
          })
          this.spaceMapData = ary
          this.$nextTick(() => {
            this.$refs.spaceMap.reloadMap()
          })
        }
      })
    },
    loadDetail() {
      const { type, id } = this.$route.params
      if (!id || !VALID_TYPES.includes(type)) {
        this.resetDetailState()
        return
      }

      this.loading = true
      this.detail = null
      this.relatedPage = 1
      this.resetSecondaryState()

      this.loadRelatedResources(1)
      this.loadRelatedEntities(id)
      this.loadGraph(id)
      this.requestSpaceMapData()

      fetchKnowledgeEntityDetail(id)
        .then((data) => {
          this.detail = mapKnowledgeDetail(data, type)
          recordBrowseHistory(LOG_HISTORY_TYPE.ENTITY, id)
        })
        .catch(() => {
          this.detail = null
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetDetailState() {
      this.detail = null
      this.loading = false
      this.resetSecondaryState()
    },
    resetSecondaryState() {
      this.relatedResources = []
      this.relatedTotal = 0
      this.relatedLoading = false
      this.relatedEntities = []
      this.relatedEntitiesLoading = false
      this.orgEventList = []
      this.orgEventCoordinate = []
      this.graphData = { nodes: [], relations: [], focusEntityId: null, focusNodeId: null, hasData: false }
      this.graphLoading = false
    },
    async loadRelatedEntities(entityId) {
      if (!entityId) {
        return
      }
      this.relatedEntitiesLoading = true
      try {
        this.relatedEntities = await fetchKnowledgeRelatedEntities(entityId)
      } catch (error) {
        this.relatedEntities = []
      } finally {
        this.relatedEntitiesLoading = false
      }
      if (this.entityType === 'jigou' || this.entityType === 'renwu') {
        const { events, coordinate } = mapRelatedEntitiesToEventData(this.relatedEntities)
        this.orgEventList = events
        this.orgEventCoordinate = coordinate
      }
    },
    async loadRelatedResources(page = this.relatedPage) {
      const entityId = this.$route.params.id
      if (!entityId) {
        return
      }
      this.relatedLoading = true
      this.relatedPage = page
      try {
        const { records, total } = await fetchEntityRelatedResources({
          entityId,
          page,
          limit: this.relatedPageSize
        })
        this.relatedResources = records || []
        this.relatedTotal = total || 0
      } catch (error) {
        this.relatedResources = []
        this.relatedTotal = 0
      } finally {
        this.relatedLoading = false
      }
    },
    async loadGraph(entityId) {
      this.graphLoading = true
      try {
        const data = await fetchKnowledgeEntityGraph(entityId)
        this.graphData = mapKnowledgeGraph(data, entityId)
      } catch (error) {
        this.graphData = { nodes: [], relations: [], focusEntityId: null, focusNodeId: null, hasData: false }
      } finally {
        this.graphLoading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/event-design.scss';

.entity-detail {
  min-height: 100vh;
  background:
    url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.035'/%3E%3C/svg%3E"),
    $color-paper;

  &__body {
    max-width: $container-max-width;
    margin: 0 auto;
    padding: $spacing-2xl $content-padding $spacing-4xl;

    &--top {
      padding-top: calc(#{$header-height} + #{$spacing-2xl});
    }
  }

  &__event {
    padding-top: 0;
    min-height: event-rem(64);
  }

  &__empty {
    padding: calc(#{$header-height} + #{$spacing-4xl}) $content-padding $spacing-4xl;
    text-align: center;
    color: $color-text-light;

    p {
      margin-bottom: $spacing-base;
      font-size: rem(16);
    }
  }

  &__back {
    color: $success-color;
    font-size: rem(14);

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
